/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.10.1.0 (NJsonSchema v10.3.3.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming
import { mergeMap as _observableMergeMap, catchError as _observableCatch } from 'rxjs/operators';
import { Observable, throwError as _observableThrow, of as _observableOf } from 'rxjs';
import { Injectable, Inject, Optional, InjectionToken } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse, HttpResponseBase } from '@angular/common/http';
export const API_BASE_URL = new InjectionToken<string>('API_BASE_URL');

export enum AllowanceCalculationType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}
export enum ApiErrorCode {
    _1 = 1,
    _2 = 2,
}
export enum BenefitType {
    _1 = 1,
    _2 = 2,
}
export enum CheckListProcessType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}
export enum DeviceType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}
export enum EmployeeType {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}
export enum RequestStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
    _3 = 3,
}
export enum ResponsibilityType {
    _1 = 1,
    _2 = 2,
}
export enum ThumbApplicationFromType {
    _1 = 1,
    _2 = 2,
    _3 = 3,
}
export enum ThumbApplicationType {
    _1 = 1,
    _2 = 2,
}
export enum ThumbSource {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}
export enum TransactionStatus {
    _0 = 0,
    _1 = 1,
    _2 = 2,
}
export enum VehicleType {
    _1 = 1,
    _2 = 2,
}
